import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Close } from '@mui/icons-material';
import { Modal } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Button, Pagination } from "antd";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { filter } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Dropzone from "react-dropzone";
import { useDispatch } from "react-redux";
import { useOneGameCategory } from "store/1GameCategory/selectors";
import { useOneGameGallery } from "store/1GameGallery/selectors";
import styled from "styled-components";
import { AllDataIdOneGame } from "utils/config/reference";
import COLOR from "utils/constants/color";
import { getImageThumbPrimaryUrl } from "utils/methods/storageImageThumbSrcList";
const ImageThemeModal = ({
  open,
  setOpen,
  uploadToStorage,
  currentIndex,
  handleUpdateCell,
}) => {
  const showAlert = useAlert();
  const categoryData = useOneGameCategory();
  const galleryCategory = useMemo(() => {
    return categoryData[0]?.meta_data;
  }, [categoryData]);
  const gallery = useOneGameGallery();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);
  const [dataTab, setDataTab] = useState(
    galleryCategory ? galleryCategory[0]?.id : AllDataIdOneGame
  );
  const [filtertedData, setFilteredData] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [gameGallery, setGameGallery] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    severity: 'error'
  });

  const filterTutorialGallery = filter(
    gallery,
    (item) => item.category === dataTab
  );
  const getCategory = galleryCategory?.find((val) => val.id === dataTab);
  const dispatch = useDispatch();

  // const fetchItem = async () => {
  //   setIsLoading(true);
  //   try {
  //     await dispatch(handleListOneGameGallery());
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const fetchCategoryList = async () => {
  //   setIsLoading(true);
  //   try {
  //     await dispatch(handleListOneGameCategory("pictures_categories"));
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  
  useEffect(() => {
    setGameGallery(gallery);
  }, [gallery]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    if (getCategory?.value === "All") {
      setFilteredData(gameGallery?.slice(startIndex, endIndex));
      setTotalPages(Math.ceil(gameGallery?.length / itemsPerPage));
      return;
    }
    setTotalPages(Math.ceil(filterTutorialGallery?.length / itemsPerPage));
    setFilteredData(filterTutorialGallery.slice(startIndex, endIndex));
  }, [dataTab, gameGallery, currentPage, getCategory]);

  useEffect(() => {
    // fetchCategoryList();
    // fetchItem();
    setDataTab(AllDataIdOneGame);
  }, []);

  const handleSubmit = async () => {
    if (selectedFile) {
      setUploadInProgress(true);
      try {
        const uploadedUrl = await uploadToStorage(selectedFile);
        handleUpdateCell(currentIndex, { imageUrl: uploadedUrl });
        setOpen(false);
      } catch (error) {
        Sentry.captureException(`627 Error in handleSubmit: ${error}`);
        console.error("Upload failed:", error);
      } finally {
        setUploadInProgress(false);
        setSelectedFile(null);
      }
    } else if (selectedUrl) {
      handleUpdateCell(currentIndex, { imageUrl: selectedUrl });
      setOpen(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const updateDisplayedData = (newPage) => {
    const startIndex = (newPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    if (getCategory?.value === "All") {
      setFilteredData(gameGallery?.slice(startIndex, endIndex));
      return;
    }
    setFilteredData(filterTutorialGallery.slice(startIndex, endIndex));
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    updateDisplayedData(newPage);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button className="ant-pagination-item-link">
          <LeftOutlined />
        </button>
      );
    }
    if (type === "next") {
      return (
        <button className="ant-pagination-item-link">
          <RightOutlined />
        </button>
      );
    }
    return originalElement;
  };

  const getUrl = (image) => {
    const file_url = image.thumbnail || image.image_url;
    return file_url ? getImageThumbPrimaryUrl(file_url) : file_url;
  };

  const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
    
    if (rejectedFiles?.length > 0) {
      // Check if file was rejected due to size
      const file = rejectedFiles[0].file;
      if (file.size > 10485760) {
        showAlert(`File "${file.name}" is too large. Maximum size is 10MB.`, "error");
      }
      return;
    }

    // Handle accepted files
    if (acceptedFiles?.length > 0) {
      setSelectedUrl("");
      setSelectedFile(acceptedFiles[0]);
    }
  }, []);

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertState(prev => ({ ...prev, open: false }));
  };

  useEffect(() => {
    if (galleryCategory?.length) {
      const allTab = galleryCategory.find(item => item.value === "All");
      setDataTab(allTab?.id || galleryCategory[0]?.id);
    }
  }, [galleryCategory]);
  

  return (
    <>
      {open && (
        <Modal
          open={open}
          onClose={handleCancel}
          disableEscapeKeyDown={true}
          onKeyDown={(e) => e.preventDefault()}
          disableRestoreFocus
          disableAutoFocus
          disableEnforceFocus
        >
          <ModalContent>
            <CloseButton onClick={handleCancel}>
              <Close style={{ color: "red" }} />
            </CloseButton>
            <div style={{ width: "100%" }} className="galleryPic loterialGalleryPic">
              <MenuWrapper top={"10px"} style={{ width: "100%" }}>
                {galleryCategory?.map((category) => (
                  <MenuBtn
                  style={{
                    borderBottom:
                      dataTab === category?.id ? "5px solid rgb(28,49,115)" : "5px solid #fcfcfc",
                    color: dataTab === category?.id ? "rgb(28,49,115)" : "black"
                  }}
                    key={category.id}
                    onClick={() => {
                      setCurrentPage(1);
                      setDataTab(category.id);
                    }}
                    className={`${dataTab === category.id ? "active" : ""}`}
                  >
                    {category.value}
                  </MenuBtn>
                ))}
              </MenuWrapper>

              {/* {isLoading ? (
                <LoadingWrapper>
                  <Loading />
                </LoadingWrapper>
              ) : ( */}
                <UnOrderedList>
                  {filtertedData?.map((item) => (
                    <ListItem
                      onClick={() => {
                        setSelectedFile(null);
                        setSelectedUrl(getUrl(item));
                      }}
                      key={item.id}
                      isActive={selectedUrl === getUrl(item)}
                    >
                      <Image
                        src={getUrl(item)}
                        alt=""
                        className={
                          selectedUrl === getUrl(item) ? "selected" : ""
                        }
                      />
                    </ListItem>
                  ))}
                </UnOrderedList>
              {/* )} */}
            </div>
            {/* <div className="paginated-image-container"> */}
              {((getCategory?.value === "All" &&
                gameGallery?.length > itemsPerPage) ||
                (getCategory?.value !== "All" &&
                  filterTutorialGallery?.length > itemsPerPage)) && (
                <Pagination
                  current={currentPage}
                  total={getCategory?.value === "All" ? gameGallery?.length : filterTutorialGallery?.length}
                  align="end"
                  pageSize={itemsPerPage}
                  showSizeChanger={false}
                  itemRender={itemRender}
                  onChange={handlePageChange}
                  className="antd-pagination"
                />
              )}
            {/* </div> */}
            {/* {isLoading ? null : ( */}
              <DropZoneContainer>
                <DropRow>
                  <CenterWrapper>
                    <Dropzone
                      accept={{
                        "image/jpeg": [".jpg", ".jpeg"],
                        "image/png": [".png"],
                        "image/gif": [".gif"],
                        "image/webp": [".webp"]
                      }}
                      minSize={1024}
                      maxSize={10485760}
                      onDrop={handleDrop}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps, isDragActive }) => (
                        <DropzoneDiv {...getRootProps()} isDragActive={isDragActive}>
                          <input {...getInputProps()} accept="image/*" />
                          <p style={{marginBottom:"0px"}}>Drag and drop file here, or click to select file</p>
                        </DropzoneDiv>
                      )}
                    </Dropzone>
                  </CenterWrapper>

                  <SubmitContainer>
                    <Button
                      style={{ background: "#16a085", color: "#fff" }}
                      onClick={handleSubmit}
                      disabled={uploadInProgress}
                    >
                      {uploadInProgress ? "Uploading..." : "Submit"}
                    </Button>
                  </SubmitContainer>
                </DropRow>
                {selectedFile && (
                  <div className="nwGaleryPrevw">
                    <p>Preview:</p>
                    <img
                      src={
                        selectedUrl !== ""
                          ? selectedUrl
                          : URL.createObjectURL(selectedFile)
                      }
                      alt="Preview"
                    />
                  </div>
                )}
              </DropZoneContainer>
            {/* )} */}
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

const DropzoneDiv = styled.div`
  min-height: auto;
  padding: 1.5rem 1.75rem;
  text-align: center;
  cursor: pointer;
  border: 1px dashed white;
  background-color: lightblue ;
  border-radius: 10px !important;
  color: white;
  margin-top: 15px;
`;

// const DropZoneContainer = styled.div``;

// const SubmitContainer = styled.div`
//   display: flex;
//   justify-content: end;
//   align-items: center;
//   // margin-top: 24px;
//   width: 100%;
// `;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
`;

const Image = styled.img`
  cursor: pointer;
  height: auto;
  width: 100%;
  height: 118px !important;
  object-fit: cover;
  border-radius: 10px;
  border: 2px solid transparent;
  &.selected {
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);
  }
`;

const UnOrderedList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 12px;
  gap: 3%;
  padding: 0px;
  max-height: 430px;
  overflow-y: auto;
`;

const ListItem = styled.div`
  list-style-type: none;
  // margin-bottom: 17px;
  margin-bottom: 6px;
  text-align: right;
  width: 22%;
  padding: 4px;
  border-radius: 12px;
  background-color: ${(p) => (p?.isActive ? "#020A52" : "")};

  &.selected {
    background-color: rgba(0, 255, 0, 0.1);
  }
`;

const ModalContent = styled.div`
  align-items: center;
  background-color: ${COLOR.white};
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 75%;
  padding: 16px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  height: 100vh;
  min-width: 300px;

  max-height: 668px;
  gap: 10px;

  @media screen and (max-width: 768px) {
    max-width: 90% !important;
  }
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 65px;
  // border-radius: 12px;
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: nowrap;
  overflow-x: auto;
 white-space: nowrap;
  margin-bottom: 10px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-color: #736c6c transparent !important;
`;

const MenuBtn = styled.button`
  background-color: white;
  border-top: none;
  border-left: none;
  border-right: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  white-space: nowrap;
  border-bottom: ${(props) =>
    props.className === "active"
      ? `2px solid ${COLOR.primary}`
      : "2px solid transparent"};
  color: ${(props) =>
    props.className === "active" ? COLOR.primary : COLOR.black};

  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 1000;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${COLOR.white};

  &:hover {
    background-color: ${COLOR.lightGrey};
    transform: rotate(90deg);
  }

  svg {
    width: 20px;
    height: 20px;
    color: ${COLOR.black};
  }
`;

const DropZoneContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DropRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;
`;

const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin-left: 115px;

   @media (max-width: 650px) {
    margin-left: 0px;
  }
`;

const SubmitContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
  margin-left: 10px;
`;


export default ImageThemeModal;
